import styled from 'styled-components';
import theme from '../../../../../constants/theme';

export const OfficeHoursEditSC = styled.div`
  .content {
    .error {
      padding: 10px 24px;
      margin: 15px 0;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;

      /* identical to box height, or 143% */

      color: #ff335c;
      background: rgba(255, 51, 92, 0.1);
      border-left: 2px solid #ff335c;
    }

    .inner {
      margin-top: 0;
      margin-bottom: 16px;
      margin-left: 43px;
    }

    .day {
      display: flex;

      .label {
        width: 20px;
        min-width: 20px;
        margin-top: 10px;
        margin-right: 23px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: #293157;
        mix-blend-mode: normal;
        opacity: 0.6;
      }

      .pickers {
        display: flex;
        flex-wrap: wrap;

        .rc-picker-input {
          height: 100%;
        }

        .rc-picker-range .rc-picker-input,
        .rc-picker-input {
          min-width: unset;
        }

        .rc-picker-input > input {
          padding: 4px 3px;
        }

        .rc-picker,
        .rc-picker-range,
        .rc-picker-input {
          height: 100%;
        }

        .rc-picker-range-separator {
          margin-top: 5px;
        }

        .empty-add {
          width: 120px;
          height: 47px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: none;
          outline: none;
          border-radius: 13px;
          background: #f6f6f8;
        }
      }
    }

    .validity-form {
      .validity-title {
        display: flex;
        align-items: center;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;

        /* identical to box height, or 143% */

        color: #596186;

        svg {
          margin-right: 12px;
        }
      }

      .validity-content {
        margin-top: 16px;
        margin-left: 16px;
      }

      .validity-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .small {
          margin-bottom: 0;
          margin-right: 16px;
        }
      }
    }
  }

  .footer {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #f5f5f7;
  }
`;

export const RangeSC = styled.div<{ error?: boolean }>`
  position: relative;
  width: 120px;
  height: 47px;
  margin-bottom: 20px;
  border-radius: 13px;
  background: #f6f6f8;
  box-sizing: border-box;
  border: ${({ error }) => (error ? `1px solid ${theme.colors.error}` : '1px solid transparent')};

  &:nth-child(odd) {
    margin-right: 10px;
  }

  .delete {
    display: none;
    position: absolute;
    top: -13px;
    right: -9px;
    cursor: pointer;
    border: none;
    background: none;
    outline: none;
  }

  &:hover {
    .delete {
      display: block;
    }
  }
`;
